import countryRegionData from 'country-region-data';

export const getCountriesAsOptions = () =>
  setPriorityCountries([...countryRegionData]).map(
    ({ countryName, countryShortCode }) => ({
      label: countryName,
      value: countryShortCode
    })
  );

export const getRegionsAsOptions = countryShortCode => {
  if (!countryShortCode) return false;

  const { regions = [] } = getCountryByShortCode(countryShortCode) || {};

  return regions.map(({ name, shortCode }) => ({
    label: name,
    value: shortCode
  }));
};

function getCountryByShortCode(countryShortCode) {
  return countryRegionData.find(
    country => country.countryShortCode === countryShortCode
  );
}

function setPriorityCountries(countries, priorityCountries = ['CA', 'US']) {
  priorityCountries.forEach((countryShortCode, index) => {
    const countryIndex = countries.findIndex(
      item => item.countryShortCode === countryShortCode
    );
    const country = countries[countryIndex];
    countries.splice(countryIndex, 1);
    countries.splice(index, 1, country);
  });

  return countries;
}
